import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
		page: 'loading',// 跳页面
		masker: '',// 跳浮层
		isIos: false,//
        device: '',
        dir: '',
        lastPage: '',
        posi: 0,
	},
	mutations: {
		setPage(state, page) {
			state.page = page;
		},
		setMasker(state, masker) {
			state.masker = masker;
		},
		setIsIos(state, isIos) {
			state.isIos = isIos;
		},
        setDevice(state, device) {
            state.device = device;
        },
        setDir(state, dir) {
            state.dir = dir;
        },
        setLastPage(state, lastPage) {
            state.lastPage = lastPage;
        },
        setPosi(state, posi) {
            state.posi = posi;
        },
	}
})
